(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["hitch-size-guide"] && !Shopify.designMode) return;
  try {
    (() => {
    const openGuide = (button) => {
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (dialog && !dialog.open) dialog.showModal();
    };
    document.addEventListener('click', (event) => {
      const openButton = event.target.closest('[data-hitch-size-guide-open]');
      if (openButton) openGuide(openButton);
      const closeButton = event.target.closest('[data-hitch-size-guide-close]');
      if (closeButton) closeButton.closest('dialog')?.close();
      const tab = event.target.closest('[data-hitch-size-guide-tab]');
      if (!tab) return;
      const dialog = tab.closest('dialog');
      dialog.querySelectorAll('[data-hitch-size-guide-tab]').forEach((button) => {
        const active = button === tab;
        button.classList.toggle('is-active', active);
        button.setAttribute('aria-selected', String(active));
      });
      dialog.querySelectorAll('[data-hitch-size-guide-panel]').forEach((panel) => {
        panel.hidden = panel.dataset.hitchSizeGuidePanel !== tab.dataset.hitchSizeGuideTab;
      });
    });
    document.addEventListener('click', (event) => {
      if (event.target.matches('.hitch-size-guide')) event.target.close();
    });
  })();
  } catch(e) { console.error(e); }
})();

})();
